export type LocalityGroup = 'inside' | 'outside';

/** Chip selection: 'both' is Everywhere; omit from the URL when both. */
export type LocalityFilter = 'both' | LocalityGroup;

export const LOCALITY_FILTERS: { key: LocalityFilter; label: string }[] = [
  { key: 'both', label: 'Everywhere' },
  { key: 'inside', label: 'In town' },
  { key: 'outside', label: 'Outside town' },
];

export const LOCALITY_LABELS: Record<LocalityGroup, string> = {
  inside: 'In town',
  outside: 'Outside town',
};

export const LOCALITY_BLURBS: Record<LocalityGroup, string> = {
  inside: 'Carvoeiro, Rocha Brava, Alfanzina — walk or a short drive.',
  outside: 'Lagoa, Benagil, Portimão and further afield.',
};

export interface LocalityInput {
  slug?: string | null;
  locality?: LocalityGroup | string | null;
}

export function localityOf(place: LocalityInput): LocalityGroup {
  return place.locality === 'inside' ? 'inside' : 'outside';
}

export function parseLocalityFilter(value: string | null | undefined): LocalityFilter {
  return value === 'inside' || value === 'outside' || value === 'both' ? value : 'both';
}

export function placeMatchesLocality(place: LocalityInput, filter: LocalityFilter): boolean {
  if (filter === 'both') return true;
  return localityOf(place) === filter;
}

export function groupByLocality<T extends LocalityInput>(places: readonly T[]): Record<LocalityGroup, T[]> {
  const out: Record<LocalityGroup, T[]> = { inside: [], outside: [] };
  for (const p of places) out[localityOf(p)].push(p);
  return out;
}
